import * as React from "react";
import { Slot } from "src/containers/event/event.types";

interface SlotSpeakersProps {
  slot: Slot;
  isBookedOrFull?: boolean;
}

export const SlotSpeakers: React.FC<SlotSpeakersProps> = ({ slot, isBookedOrFull }) =>
  Array.isArray(slot.speakers) && slot.speakers.length > 0 ? (
    <div className={`d-flex flex-column align-items-start w-100 p-2 gap-2 ${isBookedOrFull ? "bg-lvl2" : "bg-lvl1"}`}>
      <div className="d-flex align-items-center gap-1">
        <span className="icon icon-sm">campaign</span>
        <span className="fs-16 fw-semibold">Speaker</span>
      </div>
      <span className="fs-14 text-secondary ms-4">{slot.speakers.map((s) => s.friendlyName).join(", ")}</span>
    </div>
  ) : null;
